import React from "react";

export const PageHeader = ({ label, title, subtitle, testid }) => (
  <section className="bg-[#2B2B2B] text-[#F7F3EC]" data-testid={testid}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 lg:py-28">
      <p className="section-label animate-fade-up">{label}</p>
      <h1
        className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter mt-4 max-w-3xl animate-fade-up"
        style={{ animationDelay: "0.08s" }}
      >
        {title}
      </h1>
      {subtitle && (
        <p
          className="text-[#F7F3EC]/70 text-base md:text-lg mt-6 max-w-2xl leading-relaxed animate-fade-up"
          style={{ animationDelay: "0.16s" }}
        >
          {subtitle}
        </p>
      )}
    </div>
  </section>
);
